import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BadgeBitrise = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M9.56 3.435 8 2 6.44 3.435l-2.148-.29-.375 2.034L2 6.146 2.953 8 2 9.854l1.917.967.375 2.033 2.148-.289L8 14l1.56-1.435 2.148.29.375-2.034L14 9.854 13.047 8 14 6.146l-1.917-.967-.375-2.033-2.148.289Z"
      fill="#11BBA9"
      fillRule="evenodd"
    />
    <path
      d="M8.482 10.4c1.03 0 1.714-.698 1.714-1.476 0-.864-.828-1.188-.828-1.188s.576-.324.576-1.044c0-.684-.648-1.332-1.584-1.332H6.2v5.04h2.282ZM7.28 9.5V8.204h1.152c.396 0 .684.288.684.648 0 .36-.288.648-.684.648H7.28Zm1.008-3.24c.36 0 .576.216.576.54 0 .324-.216.54-.576.54H7.28V6.26h1.008Z"
      fill="#fff"
    />
  </Icon>
));

export default BadgeBitrise;
